import React from 'react';
import RoundedButton from 'components/RoundedButton';
import { getCta } from 'utils/common';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';

interface IProps {
  overrideLabel?: string;
  overrideUrl?: string;
  id?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const StandardCTA = observer(
  ({ overrideLabel, overrideUrl, id, onClick, style = {} }: IProps) => {
    const { currentUser } = useUserStore();

    const cta = getCta(currentUser);

    if (!cta) {
      return null;
    }

    return (
      <RoundedButton
        href={overrideUrl || (!onClick ? cta.url : undefined)}
        id={id}
        className="standardCTA"
        onClick={onClick}
        style={{ ...style }}
      >
        {overrideLabel || cta.label}
      </RoundedButton>
    );
  }
);

export default StandardCTA;
